import { useUserName } from "@/hooks/useUserName";
import { useClub } from "@/contexts/ClubContext";

export const useHome = () => {
  const { selectedClubName, setSelectedClub, clubs } = useClub();
  const userName = useUserName();

  const selectClub = (clubId: string) => {
    setSelectedClub(clubId);
  };

  return {
    selectedClubValue: selectedClubName,
    selectClub,
    setSelectedClubValue: (value: string) => {
      const club = clubs.find((c) => c.title === value);
      if (club) {
        setSelectedClub(club.id);
      }
    },
    userName,
  };
};
